import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The `}<Globals name="env" mdxType="Globals" />{` includes the CLI Tools Docker image`}</p>
    </PageDescription>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/cloud-native-toolkit/ibm-garage-cli-tools",
        "title": "IBM Garage for Cloud Developer Tools Docker image"
      }}>{`IBM Garage command-line tools`}</a>{` is a Docker image with many useful IBM Cloud CLI tools already installed. Rather than installing all of these tools on your local computer, you can simply pull and run this image.`}</p>
    <h2>{`Running the client`}</h2>
    <InlineNotification mdxType="InlineNotification">
      <p>{`You must `}<a parentName="p" {...{
          "href": "https://www.docker.com/products/docker-desktop"
        }}>{`install Docker Desktop`}</a>{` on your local computer to run this Docker image.`}</p>
    </InlineNotification>
    <p>{`Start the client to use it.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`To run the `}<inlineCode parentName="p">{`icclient`}</inlineCode>{` container:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`docker run -itd --name icclient ibmgaragecloud/cli-tools
`}</code></pre>
        <p parentName="li">{`  This  assumes the image’s default name, `}<inlineCode parentName="p">{`ibm-garage-cli-tools`}</inlineCode>{`.`}</p>
      </li>
    </ul>
    <p>{`Once the client is running in the backgroud, use it by opening a shell in it.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`To use the `}<inlineCode parentName="p">{`icclient`}</inlineCode>{` container, exec shell into it:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`docker exec -it icclient /bin/bash
`}</code></pre>
        <p parentName="li">{`  Your terminal is now in the container. `}</p>
      </li>
    </ul>
    <p>{`Use this shell to run commands using the installed tools and scripts.`}</p>
    <p>{`When you’re finished running commands, to exit the client.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`To leave the `}<inlineCode parentName="p">{`icclient`}</inlineCode>{` container shell, as with any shell:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`exit
`}</code></pre>
        <p parentName="li">{`  The container will keep running after you exit its shell.`}</p>
      </li>
    </ul>
    <p>{`If the client stops:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`To run the `}<inlineCode parentName="p">{`icclient`}</inlineCode>{` container again:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`docker start icclient
`}</code></pre>
      </li>
    </ul>
    <p>{`The `}<inlineCode parentName="p">{`icclient`}</inlineCode>{` container is just a Docker container, so all `}<a parentName="p" {...{
        "href": "https://docs.docker.com/engine/reference/commandline/cli/"
      }}>{`Docker CLI commands`}</a>{` work.`}</p>
    <h2>{`Using the client`}</h2>
    <p>{`From a client shell, run `}<inlineCode parentName="p">{`image-help`}</inlineCode>{` to get a list of available tools, scripts, and ENV properties:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ image-help
Available env properties (can be overridden for individual commands):
 > BM_API_KEY - the IBM Cloud api key
 > REGION - the IBM Cloud region (e.g. us-south)
 > RESOURCE_GROUP - the IBM Cloud resource group
 > CLUSTER_NAME - the name of the kubernetes cluster in IBM Cloud
 > SL_USERNAME - the Classic Infrastructure user name or API user name (e.g. 282165_joe@us.ibm.com)
 > SL_API_KEY - the Classic Infrastructure api key

Available tools:
 > terraform (with helm, kube, and ibm provider plugins)
 > calicoctl
 > ibmcloud (with container-service, container-registry, and cloud-databases plugins)
 > kubectl
 > kustomize
 > oc
 > helm
 > docker
 > git
 > nvm
 > node (v11.12.0 currently installed)
 > solsa
 > yo

Available scripts:
 > init.sh {BM_API_KEY} {REGION} {RESOURCE_GROUP} {CLUSTER_NAME}
 > createNamespaces.sh
 > deleteNamespace.sh
 > installHelm.sh
 > cluster-pull-secret-apply.sh
 > setup-namespace-pull-secrets.sh
 > checkPodRunning.sh
 > copy-secret-to-namespace.sh
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      